var AcceptableResponses_1;
import { __decorate } from "tslib";
import { AsnPropTypes, AsnArray, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
let AcceptableResponses = AcceptableResponses_1 = class AcceptableResponses extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, AcceptableResponses_1.prototype);
    }
};
AcceptableResponses = AcceptableResponses_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.ObjectIdentifier })
], AcceptableResponses);
export { AcceptableResponses };
